import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statItems = [
    {
      icon: 'CheckCircle',
      value: stats.totalProjects,
      label: 'Successful Projects',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      icon: 'Clock',
      value: stats.avgTimeSaved,
      label: 'Average Time Saved',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      icon: 'TrendingDown',
      value: `₹${stats.totalSavings}`,
      label: 'Total Cost Savings',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      icon: 'Star',
      value: stats.avgRating,
      label: 'Average Rating',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="bg-card rounded-lg construction-shadow p-8 mb-12">
      <div className="text-center mb-8">
        <h2 className="font-headline font-bold text-2xl text-card-foreground mb-2">
          Our Impact in Numbers
        </h2>
        <p className="text-muted-foreground">
          Real results from real projects across Pune and Maharashtra
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {statItems.map((item, index) => (
          <div
            key={index}
            className="text-center p-6 rounded-lg transition-construction hover:scale-105"
          >
            <div className={`inline-flex items-center justify-center w-16 h-16 ${item.bgColor} rounded-full mb-4`}>
              <Icon name={item.icon} size={24} className={item.color} />
            </div>
            <div className={`text-3xl font-bold ${item.color} mb-2`}>
              {item.value}
            </div>
            <p className="text-sm text-muted-foreground font-medium">
              {item.label}
            </p>
          </div>
        ))}
      </div>

      {/* Additional Insights */}
      <div className="mt-8 pt-8 border-t border-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div>
            <p className="text-2xl font-bold text-primary mb-1">{stats.repeatClients}%</p>
            <p className="text-sm text-muted-foreground">Repeat Clients</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-success mb-1">{stats.approvalRate}%</p>
            <p className="text-sm text-muted-foreground">Approval Success Rate</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-secondary mb-1">{stats.avgProjectSize}</p>
            <p className="text-sm text-muted-foreground">Average Project Size</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;